import clsx from "clsx";
import Reveal from "@/components/animation/reveal";

export default function RecordsGalleryHero({ title, label, intro, introClassName, headingLevel = "h1", subheadingLevel = "h2" }) {
  const HeadingTag = headingLevel;
  const SubheadingTag = subheadingLevel;

  return (
    <Reveal className="flex flex-col items-center relative">
      {title && <HeadingTag className={clsx("heading-1-small xl:heading-1 text-center mb-(--space-6)", !label && 'mb-10 xl:mb-(--space-8)')}>{title}</HeadingTag>}
      {label && <SubheadingTag className="max-lg:w-[70%] heading-6-small xl:heading-6 text-center mb-(--space-9) xl:mb-[3.125rem]">{label}</SubheadingTag>}
      {intro && <p className={clsx("text-center max-w-120 xl:max-w-148 body-1-small xl:body-1 max-md:px-(--space-6) text-pretty", headingLevel === "h1" ? "mb-(--space-11) xl:mb-[5.375rem]" : "mb-20 xl:mb-[2.875rem]", introClassName)}>{intro}</p>}
    </Reveal>
  );
}
